import React from "react";

const CalculatorIcon = ({color}) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.25 1V19.5M1 10.25H19.5M12.6135 5.963H17.1135M13.395 12.596L16.395 17.096M3.878 12.911L7.878 16.8795M7.8585 12.8795L3.878 16.864M5.878 3.713V8.213M3.628 5.963H8.128M3 1H17.5C18.0304 1 18.5391 1.21071 18.9142 1.58579C19.2893 1.96086 19.5 2.46957 19.5 3V17.5C19.5 18.0304 19.2893 18.5391 18.9142 18.9142C18.5391 19.2893 18.0304 19.5 17.5 19.5H3C2.46957 19.5 1.96086 19.2893 1.58579 18.9142C1.21071 18.5391 1 18.0304 1 17.5V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export default CalculatorIcon;
